import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { server } from "../server";
import { fetchProfileById } from "./profileSlice";

export const fetchActivityData = createAsyncThunk(
  "activity/fetchActivityData",
  async (userId, { dispatch }) => {
    try {
      const token = await localStorage.getItem("authToken");
      const headers = { Authorization: token };

      const [sentRes, receivedRes, friendsRes] = await Promise.all([
        fetch(`${server}/requests/GetAllSentRequests?userId=${userId}`, {
          headers,
        }),
        fetch(`${server}/requests/GetAllReceivedRequests?userId=${userId}`, {
          headers,
        }),
        fetch(
          `${server}/friends/GetAllFriendsOfParticularUser?userId=${userId}`,
          { headers }
        ),
      ]);

      const [sentData, receivedData, friendsData] = await Promise.all([
        sentRes.json(),
        receivedRes.json(),
        friendsRes.json(),
      ]);

      // Helper to get profile details via dispatching fetchProfileById thunk
      const getProfileDetails = async (id) => {
        const result = await dispatch(fetchProfileById(id));
        if (fetchProfileById.fulfilled.match(result)) {
          return result.payload?.user || result.payload;
        }
        return null;
      };

      const sentRequests = await Promise.all(
        (sentData.requests || []).map(async (req) => ({
          ...req,
          profileDetails: await getProfileDetails(req.receiverId),
        }))
      );

      const receivedRequests = await Promise.all(
        (receivedData.requests || []).map(async (req) => ({
          ...req,
          profileDetails: await getProfileDetails(req.senderId),
        }))
      );

      const acceptedRequests = await Promise.all(
        (friendsData.friends || []).map(async (friend) => {
          return {
            ...friend,
            profileDetails: await getProfileDetails(friend._id),
          };
        })
      );

      return { sentRequests, receivedRequests, acceptedRequests };
    } catch (error) {
      throw error;
    }
  }
);

const activitySlice = createSlice({
  name: "activity",
  initialState: {
    sentRequests: [],
    receivedRequests: [],
    acceptedRequests: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchActivityData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchActivityData.fulfilled, (state, action) => {
        state.sentRequests = action.payload.sentRequests;
        state.receivedRequests = action.payload.receivedRequests;
        state.acceptedRequests = action.payload.acceptedRequests;
        state.loading = false;
      })
      .addCase(fetchActivityData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default activitySlice.reducer;
